<section class="remove-dialog" aria-labelledby="remove-dialog-title">
  <header class="remove-dialog__header">
    <h2 id="remove-dialog-title">{{ content.h1 }}</h2>
    <button
      type="button"
      class="remove-dialog__close"
      mat-dialog-close
      aria-label="Fechar confirmação"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <div class="remove-dialog__divider"></div>

  <p class="remove-dialog__message">{{ content.p }}</p>
  <button type="button" primary-button="pv-red" (click)="confirmRemoval()">
    {{ content.button }}
  </button>
</section>
